import React, {useState, useEffect} from 'react';
import './ErrorToast.css';

export const ErrorToast = ({message}) => {
   
  return (
  
        <div className='error-toast'>
            <div className='error-message'>{message}</div>
        </div>
    
  )
}


